import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import MapBase from './MapBase';
import { ZIP_CODES } from '../../../../../api-server/constants';

const formatName = (caps) => {
  const firstLetter = caps[0];
  const rest = caps.slice(1).toLowerCase();
  return firstLetter.concat(rest);
};

const getZIPCounties = (zip) => {
  const foundCounties = [];
  for (const county in ZIP_CODES) {
    const codes = ZIP_CODES[county];
    if (codes.includes(zip)) {
      foundCounties.push(formatName(county));
    }
  }
  return foundCounties;
};

export default function HudsonValleyMap({ chartData }) {
  const { palette } = useTheme();

  const counties = {
    Dutchess: {
      color: palette.secondary.main,
      value: 0,
    },
    Orange: {
      color: palette.warning.main,
      value: 0,
    },
    Putnam: {
      color: palette.info.main,
      value: 0,
    },
    Rockland: {
      color: '#C05A9A',
      value: 0,
    },
    Sullivan: {
      color: palette.primary.main,
      value: 0,
    },
    Ulster: {
      color: palette.error.main,
      value: 0,
    },
    Westchester: {
      color: palette.success.main,
      value: 0,
    },
  };
  for (const { alertZIP } of chartData) {
    let incrementBy = 1;
    const foundCounties = getZIPCounties(alertZIP);
    if (foundCounties.length > 1) {
      incrementBy = Number((1 / foundCounties.length).toFixed(2));
    }
    for (const county of foundCounties) {
      counties[county].value += incrementBy;
    }
  }
  return (
    <Box sx={{ height: '400px', width: '400px' }}>
      <MapBase countyData={counties} />
    </Box>
  );
}
